<template>
    <div class="m-jargonCard u-br u-shadow u-bgWhite u-p10 u-mb10">
      <div class="m-jargonCard__inner">
        <div v-if="item.image1" class="m-jargonCard__imgHolder u-posRelative u-br u-overflowHidden">
          <img :src="item.image1" class="m-jargonCard__img u-cover">
        </div>
        <div class="m-jargonCard__content">
          <h3 class="m-jargonCard__title u-fs16">{{ item.title }}</h3>
          <div class="m-jargonCard__right">
            <div 
              class="a-iconButton"
              @click="playAudio"
            >
              <i v-if="!isPlaying" class='bx bx-volume-low'></i>
              <i v-else class='bx bx-volume-full'></i>
            </div>
  
            <!-- Render the audio tag only after playAudio is triggered -->
            <audio
              v-if="showAudio"
              class="m-jargonCard__player"
              ref="audioPlayer"
              controls
              autoplay
              @play="onPlay"
              @pause="onPause"
            >
              <source :src="item.audio_file" type="audio/mpeg" />
              {{ $t('module.noSupportAudio') }}
            </audio>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, nextTick } from 'vue';
  
  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  });
  
  const audioPlayer = ref(null);
  const isPlaying = ref(false);
  const showAudio = ref(false);
  
  const playAudio = async () => {
    if (!showAudio.value) {
      showAudio.value = true;
      await nextTick();
    }
  
    if (audioPlayer.value) {
      if (isPlaying.value) {
        audioPlayer.value.pause();
      } else {
        audioPlayer.value.play();
      }
    }
  };
  
  const onPlay = () => {
    isPlaying.value = true;
  };
  
  const onPause = () => {
    isPlaying.value = false;
  };
  </script>
  